// Mini vertical soccer pitch (attacking upward) with a glow on the player's zone.
const ZONES = {
  GK: [34, 96], CB: [34, 85], LB: [11, 81], RB: [57, 81],
  CDM: [34, 67], CM: [34, 53], CAM: [34, 39],
  LW: [12, 24], RW: [56, 24], ST: [34, 11],
};

const ALIASES = {
  GOALKEEPER: "GK", KEEPER: "GK",
  DEFENDER: "CB", "CENTRE BACK": "CB", "CENTER BACK": "CB", "CENTRE-BACK": "CB", CBACK: "CB",
  "LEFT BACK": "LB", "LEFT-BACK": "LB", LWB: "LB",
  "RIGHT BACK": "RB", "RIGHT-BACK": "RB", RWB: "RB",
  "DEFENSIVE MIDFIELDER": "CDM", DM: "CDM",
  MIDFIELDER: "CM", "CENTRAL MIDFIELDER": "CM", MID: "CM",
  "ATTACKING MIDFIELDER": "CAM", AM: "CAM", PLAYMAKER: "CAM",
  "LEFT WING": "LW", "LEFT WINGER": "LW",
  "RIGHT WING": "RW", "RIGHT WINGER": "RW", WINGER: "RW",
  STRIKER: "ST", FORWARD: "ST", CF: "ST", "CENTRE FORWARD": "ST",
};

export function resolvePosition(raw) {
  const p = (raw || "").trim().toUpperCase();
  if (ZONES[p]) return p;
  return ALIASES[p] || null;
}

const line = { stroke: "#404040", strokeWidth: 0.8, fill: "none" };

export default function PitchHeatmap({ position }) {
  const key = resolvePosition(position);
  if (!key) return null;
  const [x, y] = ZONES[key];

  return (
    <svg
      data-testid="pitch-heatmap"
      viewBox="0 0 68 105"
      className="w-full h-full"
      role="img"
      aria-label={`Position map: ${key}`}
    >
      <defs>
        <radialGradient id="pos-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
          <stop offset="45%" stopColor="#ffffff" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* pitch */}
      <rect x="1" y="1" width="66" height="103" rx="1" {...line} fill="#0a0a0a" />
      <line x1="1" y1="52.5" x2="67" y2="52.5" {...line} />
      <circle cx="34" cy="52.5" r="8" {...line} />
      <circle cx="34" cy="52.5" r="0.8" fill="#404040" />
      {/* top penalty area (attacking goal) */}
      <rect x="14" y="1" width="40" height="15" {...line} />
      <rect x="24" y="1" width="20" height="5.5" {...line} />
      {/* bottom penalty area (own goal) */}
      <rect x="14" y="89" width="40" height="15" {...line} />
      <rect x="24" y="98.5" width="20" height="5.5" {...line} />

      {/* heat zone */}
      <ellipse cx={x} cy={y} rx="17" ry="14" fill="url(#pos-glow)" opacity="0.35" />
      <ellipse cx={x} cy={y} rx="9" ry="7.5" fill="url(#pos-glow)" />
      <circle cx={x} cy={y} r="1.6" fill="#ffffff" />

      {/* position label */}
      <text
        x={x}
        y={y + (y > 90 ? -5 : 7.5)}
        textAnchor="middle"
        fill="#ffffff"
        fontSize="4.5"
        fontWeight="700"
        letterSpacing="0.5"
        style={{ fontFamily: "inherit" }}
      >
        {key}
      </text>
    </svg>
  );
}
